import { QodoAnteaterSkateboard } from '../../logos';
import { cn } from '../../utils/className';
import { spawn } from '../../utils/translations';
import { SuccessMessageProps } from './types';

export const SuccessMessage = ({
  translationKey,
  className: propsClassName,
}: SuccessMessageProps) => {
  const spawnText = spawn(translationKey);

  const className = cn(
    'flex flex-col items-center justify-center',
    propsClassName,
  );

  return (
    <section className={className}>
      <QodoAnteaterSkateboard className="mb-12" />
      <div className="flex flex-col items-center justify-center gap-3 text-center max-w-[520px]">
        <h2 className="text-[#f0f0f0]">{spawnText('title')}</h2>
        <p className="text-purple-muted-300">{spawnText('description')}</p>
      </div>
    </section>
  );
};
